import { getTranslation } from '../i18n/index';

/** Sequential highlights explain the architecture; all content stays readable when paused. */
export function initDiagramMotion(): void {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const labels = getTranslation().nav.motion;
  const refreshers: Array<() => void> = [];
  const lists = document.querySelectorAll<HTMLElement>('.hv-flow, .hv-product-grid, .hv-oem-flow, .lyr-list, .prog-list, .detail-flow');

  lists.forEach((list) => {
    const nodes = Array.from(list.children).filter((el): el is HTMLElement => el instanceof HTMLElement);
    if (nodes.length < 2) return;
    const scene = list.closest<HTMLElement>('.hv-hero-panel') ?? list;
    const video = scene.querySelector<HTMLVideoElement>('[data-hero-video]');
    const controls = document.createElement('div');
    controls.className = 'flow-controls';
    const caption = document.createElement('span');
    const motionCaption = list.dataset.motionCaption ?? labels.caption;
    caption.textContent = motionCaption;
    // `data-motion-controls="off"` dispensa o botão de pausar; a legenda fica.
    const button = list.dataset.motionControls === 'off' ? null : document.createElement('button');
    if (button) button.type = 'button';
    controls.append(caption, ...(button ? [button] : []));
    list.before(controls);
    list.classList.add('data-flow');
    nodes.forEach((node) => node.classList.add('data-flow-step'));

    let paused = reduced.matches;
    let visible = false;
    let step = 0;
    let timer: ReturnType<typeof setInterval> | undefined;
    const paint = (): void => {
      nodes.forEach((node, i) => node.classList.toggle('is-flow-active', i === step));
      scene.dataset.flowStep = String(step);
    };
    const sync = (): void => {
      if (timer) clearInterval(timer);
      timer = undefined;
      const running = visible && !paused && !reduced.matches && !document.hidden;
      list.classList.toggle('is-flow-running', running);
      scene.dataset.motionPaused = String(paused || reduced.matches);
      scene.dataset.motionVisible = String(visible && !document.hidden);
      if (button) {
        button.textContent = paused ? labels.play : labels.pause;
        button.setAttribute('aria-label', `${paused ? labels.play : labels.pause}: ${motionCaption}`);
        button.setAttribute('aria-pressed', String(!paused));
        button.disabled = reduced.matches;
      }
      if (running) {
        paint();
        timer = setInterval(() => { step = (step + 1) % nodes.length; paint(); }, 1800);
        if (video?.dataset.loaded === 'true' && window.matchMedia('(min-width: 960px)').matches) void video.play().catch(() => undefined);
      } else {
        video?.pause();
        if (reduced.matches) nodes.forEach((node) => node.classList.remove('is-flow-active'));
      }
    };
    button?.addEventListener('click', () => { paused = !paused; sync(); });
    const observer = new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      sync();
    }, { threshold: 0.15 });
    observer.observe(list);
    refreshers.push(sync);
    sync();
  });

  const refresh = (): void => refreshers.forEach((sync) => sync());
  document.addEventListener('visibilitychange', refresh);
  reduced.addEventListener('change', refresh);
}
